import React, { useState, useEffect } from "react";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import { toast } from "../../../components/toastNotification";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import {
  isEditStateProducer,
  rowForEditProducer,
  prodCodeList,
  saveButtonTextProducerCode,
  isFranchiseFilterState,
  prodEditState,
  carrierProgramOptions,
  prodCodeIsFranchise,
  carrierNameValue,
} from "./atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";
import { useCarrierProgram } from "../../Utilities/ProducerConfiguration/CarrierProgram/hooks/useCarrierProgram";
import CustomLoaderForm from "../../../components/CustomLoaderForm";
import ReactTooltip from "react-tooltip";
import { useGetMGA } from "./hooks/useGetMGA";
import { useDistributionChannelOptions } from "./hooks/useDistributionChannelOptions";
import { useLobTypeOptions } from "./hooks/useLobTypeOptions";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import useEditProdCode from "./hooks/useEditProdCode";
import { useQueryClient } from "react-query";
import { useGetCarriers } from "../Carrier/hooks/useGetCarriers";
import useGetEmployees from "./hooks/useGetEmployees";
import useGetAllFranchiseEmployees from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetAllFranchiseEmployees";
import { useGetProdType } from "./hooks/useProducerCodeType";
import { useCodeLevel } from "./hooks/useCodeLevel";
import MultiSelectInput from "../../../components/MultiSelectInput";
import { useStates } from "../hooks/useStates";
import { Controller, useFormContext } from "react-hook-form";
import { useCarrierProducerCodeList } from "./hooks/useGetCarrierProdCode";
import { useFranchiseEmployee } from "../Employees/Franchise/hooks/UseFranchiseEmployee";
import useSendEmail from "./hooks/useSendEmail";

const EditProducerCodeModal = ({ groupedProducerCodes }) => {
  const { data: allProducerCodeList } =
    useCarrierProducerCodeList(groupedProducerCodes);
  const queryClient = useQueryClient();
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditProducer);
  const [prodCodeData, setProdCodeData] = useRecoilState(prodCodeList);
  const [isFranchiseFilter, setIsFranchiseFilter] = useRecoilState(
    isFranchiseFilterState
  );
  const { mutateAsync: sendProdCodeEmail, isSuccess: emailSuccess } =
    useSendEmail();
  const data = rowForEdit;

  const producerCodeData = prodCodeData;
  const [selectedisMA, setselectedisMA] = useState(null);
  const [lob, setLob] = useState([]);
  const [prodType, setprodType] = useState([]);
  const [princetonAgentCode, setPrincetonAgentCode] = useState([]);
  const [saveButtonText, setSaveButtonText] = useRecoilState(
    saveButtonTextProducerCode
  );
  const { data: prodTypes } = useGetProdType();
  const formMethods = useFormContext();

  const prodTypesOptions = prodTypes
    ?.filter((ptypes) => ptypes.isActive === true)
    .map((x) => {
      return { label: x.producerCodeTypesName, value: x.producerCodeTypesId };
    });

  const forRollUpDefault = allProducerCodeList?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
    };
  });

  const forMasterCodeDefault = allProducerCodeList?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
    };
  });
  const rollUpCodeOptions = producerCodeData?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
      isActive: x.isActive,
      isFranchise: x.isFranchise,
    };
  });
  const masterCodeOptions = producerCodeData?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
      isActive: x.isActive,
      isFranchise: x.isFranchise,
    };
  });

  const { data: codeLevels } = useCodeLevel();
  const codeLevelOptions = codeLevels
    ?.filter((cLevels) => cLevels.isActive === true)
    .map((x) => {
      return { label: x.codeLevelName, value: x.codeLevelId };
    });
  const { data: states } = useStates();
  const allStatesOpt = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });
  const [agency, setAgency] = useState([]);
  const [distributionChannel, setDistributionChannel] = useState(null);
  const setProdEdit = useSetRecoilState(prodEditState);
  const [saveModal, setSaveModal] = useState(false);
  const [carrier, setCarrier] = useState([]);
  const [changed, setChanged] = useState(false);
  const [defaultProg, setDefaultProg] = useState();
  const [defaultRollUp, setDefaultRollUp] = useState();
  const [defaultMasterCode, setDefaultMasterCode] = useState();
  const [defaultRollUpCodeStatus, setDefaultRollUpCodeStatus] = useState(true);
  const [defaultMasterCodeStatus, setDefaultMasterCodeStatus] = useState(true);
  const [selectedCodeLevel, setSelectedCodeLevel] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isFranchiseChecked, setIsFranchiseChecked] = useState(false);
  const [isFranchise, setIsFranchise] = useRecoilState(prodCodeIsFranchise);
  const [isMasterCodeStatusChecked, setIsMasterCodeStatusChecked] =
    useState(false);
  const [isRollUpStatusChecked, setIsRollUpCodeStatusChecked] = useState(false);
  const [associatedTo, setAssociatedTo] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [selectedCarrierName, setSelectedCarrierName] = useState("");
  const [masterAgentPrincetonId, setMasterAgentPrincetonId] = useState(0);

  const associations = [
    { label: "Office", value: "Office" },
    { label: "Producer", value: "Producer" },
  ];
  const {
    mutate: updatingProducerCode,
    isError,
    isSuccess,
    data: updateResult,
    error,
  } = useEditProdCode();

  const ProducerEditCodeRow = {
    CarrierProducerCodeId: 0,
    CarrierId: 0,
    // StateId: 0,
    ProducerCode: "",
    ProducerSubCode: "string",
    isActive: true,
    ModifiedBy: "",
    Address: "",
    City: "",
    LobId: 0,
    Program: "",
    MGA: "",
    StoreNumber: "",
    OfficeCode: "",
    isMA: true,
    MAProducerCodes: "",
    AssociatedTo: "",
    Producer: "",
    isFranchise: false,
    isSuperuser: false,
    MasterCode: "",
    MasterCodeStatus: true,
    ProducerCodeTypeId: 0,
    DistributionChannelId: 0,
    CodeLevel: "",
    IssuedTo: [],
    RollUpId: 0,
    RollUpCodeStatus: true,
    CrossSale: [],
    PrincetonAgentCode: "",
    MasterAgentPrincetonId: null,
    CarrierName: "",
  };
  const [updateProducerCodeData, setUpdateProducerCodeData] =
    useState(ProducerEditCodeRow);
  const [deletedOffice, setDeletedOffice] = useState(false);
  const [selectedIssuedTo, setSelectedIssuedTo] = useState([]);
  const [selectedCrossSale, setSelectedCrossSale] = useState([]);
  const user = useRecoilValue(accountAtom);
  const cProgramOpt = useCarrierProgram();
  const { data: mgaOpt } = useGetMGA();
  const { data: employeeList } = useGetEmployees();
  const [isChannelFranchise, setIsChannelFranchise] = useState(
    user.isNonFranchise && user.isFranchise
      ? data.distributionChannelId === 6
        ? true
        : false
      : user.isFranchise
      ? true
      : false
  );

  const { data: carriers, isFetching: carrierLoading } = useGetCarriers();
  const carrierOptions = carriers
    ?.filter((ca) => ca.isActive === true)
    .map((x) => {
      return {
        label: x.carrierName,
        value: x.masterCarrierId,
      };
    });
  const { data: distChannel } = useDistributionChannelOptions();

  const distChannelOpts = distChannel
    ?.filter(
      (dist) =>
        dist.isActive === true &&
        (user?.isNonFranchise && user?.isFranchise
          ? dist.distributionChannelName !== null
          : user?.isFranchise
          ? dist.distributionChannelName !== null
          : dist.distributionChannelName !== "Franchise")
    )
    .map((x) => {
      return {
        label: x.distributionChannelName,
        value: x.distributionChannelId,
      };
    });

  const { data: lobTypes } = useLobTypeOptions();
  const loboptions = lobTypes
    ?.filter((lob) => lob.isActive === true)
    .map((x) => {
      return { label: x.lobname, value: x.lobid };
    });

  const { data: agencies, isLoading } = useSFGetOffice();
  const agenciesOptions = agencies
    ?.filter((c) => c.officeCode !== null && c.officeCode !== "")
    ?.map((x) => {
      return {
        label: x.officeName + "-" + x.officeCode,
        value: x.officeCode + "-" + x.storeNumber,
        storeNumber: x.storeNumber,
        officeCode: x.officeCode,
        state: x.stateCode,
        officeName: x.officeName,
        officeType: x.officeType,
      };
    });

  const { data: franchiseEmp } = useFranchiseEmployee();

  const franchiseEmpOpts = franchiseEmp
    ?.filter((a) => a.isActive === "true")
    ?.map((x) => {
      return {
        label: x.firstName + " " + x.lastName,
        value: x.franchiseEmployeeId,
        managerEmployeeId: x.franchiseEmployeeId,
      };
    });

  //use as identifier is useEffect is already run 1 time to avoid issue
  const [isRun, setIsRun] = useState(true);
  //Function to initialize data
  const codeStatus = [
    { label: "Active", value: true },
    {
      label: "Inactive",
      value: false,
    },
  ];
  useEffect(() => {
    if (
      isRun &&
      !isLoading &&
      prodTypesOptions &&
      codeLevelOptions &&
      carrierOptions &&
      distChannelOpts &&
      lobTypes &&
      agenciesOptions &&
      rollUpCodeOptions &&
      masterCodeOptions &&
      allProducerCodeList
    ) {
      setAssociatedTo({ label: data.associatedTo, value: data.associatedTo });
      setselectedisMA(data.isMA);
      setIsChecked(data.isActive);
      setIsFranchiseChecked(data.isFranchise);
      setIsMasterCodeStatusChecked(data.masterCodeStatus);
      setIsRollUpCodeStatusChecked(data.rollUpCodeStatus);
      setMasterAgentPrincetonId(data.masterAgentPrincetonId);

      if (isChannelFranchise) {
        for (let i = 0; i < data.issuedToList?.length; i++) {
          // franchiseEmpOpts
          //   ?.filter((x) => x.value === Number(data.issuedToList[i]))
          //   .map((x) =>
          //     selectedIssuedTo.push({
          //       label: x.label,
          //       value: x.value,
          //     })
          //   );
          employeeList
            ?.filter(
              (x) =>
                x.employeeTypeName === "Franchise" &&
                x.employeeId === Number(data.issuedToList[i])
            )
            .map((x) =>
              selectedIssuedTo.push({
                label: x.fullname + " - " + x.employeenumber,
                value: x.employeeId,
              })
            );
        }
      } else {
        for (let i = 0; i < data.issuedToList?.length; i++) {
          employeeList
            ?.filter(
              (x) =>
                x.employeeTypeName !== "Franchise" &&
                x.employeeId === Number(data.issuedToList[i])
            )
            .map((x) =>
              selectedIssuedTo.push({
                label: x.fullname + " - " + x.employeenumber,
                value: x.employeeId,
              })
            );
        }
      }

      for (let i = 0; i < data.crossSaleList?.length; i++) {
        allStatesOpt
          ?.filter(
            (x) =>
              // x.status !== "Terminated" &&
              x.label === data.crossSaleList[i]
          )
          .map((x) =>
            selectedCrossSale.push({
              label: x.label,
              value: x.value,
            })
          );
      }
      setSelectedCodeLevel({ label: data.codeLevel, value: data.codeLevel });
      if (
        carrierOptions?.filter((item) => item.value === data.masterCarrierID)
          .length > 0
      ) {
        setCarrier(
          carrierOptions?.filter(
            (item) => item.value === data.masterCarrierID
          )[0]
        );
      } else {
        setCarrier({
          value: data.masterCarrierId,
          label: data.carrierName,
        });
      }
      if (
        agenciesOptions?.filter(
          (item) =>
            item.officeCode?.toUpperCase() === data.officeCode?.toUpperCase()
        ).length > 0
      ) {
        setAgency(
          agenciesOptions?.filter(
            (item) =>
              item.officeCode?.toUpperCase() === data.officeCode?.toUpperCase()
          )[0]
        );
      } else {
        setAgency({
          value: data.officeCode + "-" + data.storeNumber,
          label: data.officeName + "-" + data.officeCode,
        });
      }
      if (data.distributionChannelName === "Franchise") {
        // setSelectedEmployee(
        //   franchiseEmpOpts &&
        //   franchiseEmpOpts?.filter((x) => x.value === Number(data.producer))
        // );
        setSelectedEmployee(
          employeeList
            ?.filter((x) => x.employeeId === Number(data.producer))
            .map((x) => {
              return {
                label:
                  x.fullname +
                  (x.employeenumber && x.fullname ? " - " : "") +
                  x.employeenumber,
                value: x.employeeId,
              };
            })
        );
        setIsFranchise(true);
      } else {
        setIsFranchise(false);
        setSelectedEmployee(
          employeeList
            ?.filter((x) => x.employeeId === Number(data.producer))
            .map((x) => {
              return {
                label:
                  x.fullname +
                  (x.employeenumber && x.fullname ? " - " : "") +
                  x.employeenumber,
                value: x.employeeId,
              };
            })
        );
      }

      if (
        agenciesOptions?.filter(
          (item) =>
            item.officeCode?.toUpperCase() === data.officeCode?.toUpperCase()
        ).length === 0
      ) {
        setDeletedOffice(true);
      }
      setDistributionChannel(
        distChannelOpts?.filter(
          (dis) => dis.label === data.distributionChannelName
        )[0]
      );
      setLob(loboptions?.filter((item) => item.value === data.lobId)[0]);
      setDefaultProg(
        cProgramOpt.data
          ?.filter(
            (x) =>
              x.carrierId ===
              carrierOptions?.filter(
                (item) => item.value === data.masterCarrierID
              )[0]?.value
          )
          .map((x) => {
            return { value: x.id, label: x.programName };
          })
          .filter((l) => l.label === data.program)[0]
      );

      setDefaultRollUp(
        rollUpCodeOptions?.filter((x) => x.value === data.rollUpId)
      );

      setDefaultRollUpCodeStatus(
        codeStatus.filter((x) => x.value === data.rollUpCodeStatus)
      );

      setDefaultMasterCodeStatus(
        codeStatus?.filter((x) => x.value === data.masterCodeStatus)
      );

      setDefaultMasterCode(
        masterCodeOptions?.filter((x) => x.label === data.masterCode)
      );

      setprodType(
        prodTypesOptions?.filter(
          (dis) => dis.value === data.producerCodeTypeId
        )[0]
      );

      if (!defaultProg && data.program) {
        setChanged(true);
      }
      const editProgram = cProgramOpt.data
        ?.filter((x) => x.programName === data.program)
        .map((y) => {
          return y.id;
        });

      if (!defaultProg && data.program) {
        setChanged(true);
      }
      const editMGA = mgaOpt
        ?.filter((x) => x.mga1 === data.mga)
        .map((y) => {
          return y.id;
        });

      setUpdateProducerCodeData({
        ...updateProducerCodeData,
        CarrierProducerCodeId: data.carrierProducerCodeId,
        CarrierId: data.masterCarrierID,
        // StateId: data.stateID,
        ProducerCode: data.producerCodes,
        ProducerSubCode: data.producerSubCodes,
        isActive: data.isActive,
        ModifiedBy: user?.username,
        Address: data.address,
        City: data.city,
        LobId: data.lobId,
        OfficeCode: data.officeCode,
        StoreNumber: data.storeNumber,
        isMA: data.isMA,
        MAProducerCodes: data.mAproducerCodes,
        Program: editProgram?.length > 0 ? editProgram[0] : 0,
        DistributionChannelId: data.distributionChannelId,
        MGA: editMGA?.length > 0 ? editMGA[0] : 0,
        Producer: data.producer,
        AssociatedTo: data.associatedTo,
        isFranchise: data.isFranchise,
        isSuperuser: user.isFranchise && user.isNonFranchise,
        ProducerCodeTypeId: data.producerCodeTypeId,
        MasterCode: data.masterCode,
        MasterCodeStatus: data.masterCodeStatus,
        CodeLevel: data.codeLevel,
        IssuedTo: data.issuedToList,
        CrossSale: data.crossSaleList,
        RollUpCodeStatus: data.rollUpCodeStatus,
        RollUpId: data.rollUpId,
        MappedToCdrc: data.mappedToCdrc,
        MappedToKeeper: data.mappedToKeeper,
        PrincetonAgentCode: data.princetonAgentCode,
        MasterAgentPrincetonId: data.masterAgentPrincetonId,
        CarrierName: data.carrierName,
      });
      setIsRun(false);
    }
  }, [
    agenciesOptions,
    cProgramOpt.data,
    carrierOptions,
    codeLevelOptions,
    data,
    defaultProg,
    distChannelOpts,
    employeeList,
    isLoading,
    isRun,
    lobTypes,
    loboptions,
    mgaOpt,
    prodTypesOptions,
    selectedIssuedTo,
    updateProducerCodeData,
    user.isFranchise,
    user.isNonFranchise,
    user?.username,
  ]);
  const handleCheckBox = (e) => {
    const checked = e.target.checked;
    const newUpdateProducerCodeData = updateProducerCodeData;
    if (checked) {
      //checked
      setIsChecked(true);
      setChanged(true);

      setUpdateProducerCodeData({
        ...newUpdateProducerCodeData,
        isActive: true,
      });
    } else {
      //unchecked
      setIsChecked(false);
      setChanged(true);

      setUpdateProducerCodeData({
        ...newUpdateProducerCodeData,
        isActive: false,
      });
    }
  };

  const handleFranchiseDistribution = (checked, distributionId) => {
    if (checked) {
      //checked
      setIsFranchiseChecked(true);
      setChanged(true);
      setSelectedIssuedTo([]);
      setAgency([]);
      setSelectedEmployee([]);
      setDefaultMasterCode("");
      setDefaultRollUp(0);
      setDefaultMasterCodeStatus(codeStatus.filter((x) => x.value === true));
      setDefaultRollUpCodeStatus(codeStatus.filter((x) => x.value === true));
      setUpdateProducerCodeData({
        ...updateProducerCodeData,
        DistributionChannelId: distributionId,
        ModifiedBy: user?.username,
        isFranchise: true,
        OfficeCode: "",
        StoreNumber: null,
        Producer: "",
        IssuedTo: [],
        MasterCode: "",
        RollUpId: 0,
        MasterCodeStatus: true,
        RollUpCodeStatus: true,
      });
    } else {
      //unchecked
      setIsFranchiseChecked(false);
      setChanged(true);
      setSelectedIssuedTo([]);
      setAgency([]);
      setSelectedEmployee([]);
      setDefaultMasterCode("");
      setDefaultRollUp(0);
      setDefaultMasterCodeStatus(codeStatus.filter((x) => x.value === true));
      setDefaultRollUpCodeStatus(codeStatus.filter((x) => x.value === true));
      setUpdateProducerCodeData({
        ...updateProducerCodeData,
        DistributionChannelId: distributionId,
        ModifiedBy: user?.username,
        isFranchise: false,
        OfficeCode: "",
        StoreNumber: null,
        Producer: "",
        IssuedTo: [],
        MasterCode: "",
        RollUpId: 0,
        MasterCodeStatus: true,
        RollUpCodeStatus: true,
      });
    }
  };

  const handleMACheckBox = (e) => {
    const checked = e.target.checked;
    const newUpdateProducerCodeData = updateProducerCodeData;
    if (checked) {
      //checked

      setselectedisMA(true);
      setChanged(true);
      setUpdateProducerCodeData({
        ...newUpdateProducerCodeData,
        isMA: true,
      });

      //  setpcodeStatus(true);
    } else {
      //unchecked
      setselectedisMA(false);
      setChanged(true);
      setUpdateProducerCodeData({
        ...newUpdateProducerCodeData,
        isMA: false,
        MAProducerCodes: "",
      });
    }
  };
  const Cancel = () => {
    setSaveButtonText("Save");
    setProdEdit(false);
    setRowForEdit([]);
    setProdCodeData([]);
    setDeletedOffice(false);
  };
  //Function for Contact Table Select Input
  const handleEditProducerModalInputs = (
    processname,
    fieldName,
    selectedValue,
    masterRollStatus,
    officeCode,
    storeNumber
  ) => {
    const newProducerCode = updateProducerCodeData;
    if (processname === "EditProducerCode") {
      setChanged(false);
      if (fieldName === "OfficeCodeStoreNumber" && selectedValue !== null) {
        setDeletedOffice(false);
        //const values = selectedValue.split(",");
        setUpdateProducerCodeData({
          ...newProducerCode,
          OfficeCode: officeCode ? officeCode : null,
          StoreNumber: storeNumber ? storeNumber : null,
          ModifiedBy: user?.username,
        });
        setChanged(true);
      } else if (
        fieldName === "OfficeCodeStoreNumber" &&
        selectedValue === null
      ) {
        setUpdateProducerCodeData({
          ...newProducerCode,
          OfficeCode: null,
          StoreNumber: null,
          ModifiedBy: user?.username,
        });
        setChanged(true);
      } else if (fieldName === "ProducerCode") {
        setUpdateProducerCodeData({
          ...newProducerCode,
          [fieldName]: selectedValue,
          ModifiedBy: user?.username,
        });
        setChanged(true);
      } else if (fieldName === "AssociatedTo") {
        if (selectedValue === "Office") {
          setSelectedEmployee(null);
          setUpdateProducerCodeData({
            ...newProducerCode,
            [fieldName]: selectedValue,
            producer: null,
            ModifiedBy: user?.username,
          });
        } else {
          setAgency(null);
          setUpdateProducerCodeData({
            ...newProducerCode,
            [fieldName]: selectedValue,
            officeCode: null,
            storeNumber: null,
            ModifiedBy: user?.username,
          });
        }
      } else if (fieldName === "MasterCode") {
        setUpdateProducerCodeData({
          ...newProducerCode,
          MasterCode: selectedValue,
          MasterCodeStatus: masterRollStatus,
          ModifiedBy: user?.username,
        });
        setDefaultMasterCodeStatus(
          codeStatus.filter((x) => x.value === masterRollStatus)
        );
        setChanged(true);
      } else if (fieldName === "RollUpId") {
        setUpdateProducerCodeData({
          ...newProducerCode,
          RollUpId: selectedValue,
          RollUpCodeStatus: masterRollStatus,
          ModifiedBy: user?.username,
        });
        setDefaultRollUpCodeStatus(
          codeStatus.filter((x) => x.value === masterRollStatus)
        );
        setChanged(true);
      } else if (fieldName === "DistributionChannelId") {
        handleFranchiseDistribution(
          selectedValue?.label === "Franchise" ? true : false,
          selectedValue?.value
        );
        selectedValue?.label === "Franchise"
          ? setIsFranchise(true)
          : setIsFranchise(false);
        setChanged(true);
      } else if (fieldName === "CarrierId") {
        setUpdateProducerCodeData({
          ...newProducerCode,
          CarrierId: selectedValue.value,
          RollUpId: 0,
          MasterCode: "",
          RollUpCodeStatus: true,
          MasterCodeStatus: true,
          ModifiedBy: user?.username,
          CarrierName: selectedValue.label,
          PrincetonAgentCode:
            selectedValue.label !== "National General" ? null : null,
          MasterAgentPrincetonId:
            selectedValue.label !== "National General" ? null : null,
        });
        setDefaultMasterCodeStatus(codeStatus.filter((x) => x.value === true));
        setDefaultRollUpCodeStatus(codeStatus.filter((x) => x.value === true));
        setChanged(true);
      } else if (fieldName === "PrincetonAgentCode") {
        setUpdateProducerCodeData({
          ...newProducerCode,
          [fieldName]: selectedValue,
        });
        setChanged(true);
      } else if (fieldName === "masterAgentPrincetonId") {
        var princetonId = "";
        selectedValue.split("").forEach((character) => {
          if (/^[0-9]*$/.test(character)) {
            return (princetonId = princetonId + character);
          }
        });
        setMasterAgentPrincetonId(princetonId);
        setUpdateProducerCodeData({
          ...newProducerCode,
          MasterAgentPrincetonId: princetonId,
        });
        setChanged(true);
      } else {
        setUpdateProducerCodeData({
          ...newProducerCode,
          [fieldName]: selectedValue,
          ModifiedBy: user?.username,
        });
        setChanged(true);
      }
    }
  };

  if (isSuccess && saveButtonText !== "Save") {
    setSaveButtonText("Save");
    if (updateResult.data === "Potential Duplicate Found") {
      toast.fire(
        "Failed",
        "Failed to Update Producer code! Already Exist.",
        "error"
      );
    } else if (updateResult.status === 200 || updateResult.status === 201) {
      sendProdCodeEmail(updateResult.data, {
        onSuccess: (res) => {
          if (res) {
            if (res.status === 400) {
              toast.fire(
                "Success",
                "Producer Code Updated Successfully, but failed in sending email",
                "warning"
              );
            } else {
              toast.fire(
                "Success",
                "Producer Code Updated Successfully",
                "success"
              );
            }
            if (
              updateProducerCodeData.CarrierId !== data.masterCarrierID ||
              updateProducerCodeData.AssociatedTo !== data.associatedTo
            ) {
              queryClient.invalidateQueries("ProducerCode");
            } else if (isFranchiseFilter) {
              setIsFranchiseFilter(false);
              queryClient.invalidateQueries("FilteredData");
            } else {
              queryClient.invalidateQueries("ProducerCodeList");
            }
            setProdEdit(false);
          }
        },
        onError: (error) => {
          toast.fire(
            "Success",
            "Producer Code Updated Successfully, but failed in sending email",
            "warning"
          );
        },
      });
    } else if (updateResult.status === 500) {
      if (
        updateResult.data.message === "Failed sending of email" ||
        updateResult.data.message === "Failed inserting of notification"
      ) {
        toast.fire(
          "Warning",
          "Producer Codes updated successfully, but " +
            updateResult.data.message,
          "warning"
        );
        queryClient.invalidateQueries("ProducerCode");
        queryClient.invalidateQueries("ProducerCodeList");
      } else {
        toast.fire("Failed", "Failed to Update Producer Code", "error");
      }
    } else {
      toast.fire("Server Error", "Failed to Update Producer code.", "error");
    }

    setSaveButtonText("Save");
  }
  if (isError) {
    setSaveButtonText("Save");
    toast.fire("Failed", "Failed to Update Producer Code", "error");
  }

  const ValidateRequiredFields = () => {
    if (changed) {
      if (
        updateProducerCodeData.ProducerCode &&
        (updateProducerCodeData.AssociatedTo === "Office"
          ? updateProducerCodeData.OfficeCode
          : updateProducerCodeData.Producer) &&
        updateProducerCodeData.LobId !== 0 &&
        updateProducerCodeData.LobId &&
        updateProducerCodeData.CarrierId !== 0 &&
        updateProducerCodeData.CarrierId &&
        ((carrier.label === "National General" &&
          updateProducerCodeData.PrincetonAgentCode) ||
          carrier.label !== "National General") &&
        updateProducerCodeData.CodeLevel &&
        updateProducerCodeData.ProducerCodeTypeId !== 0
      ) {
        // if (
        //   ((carrier.label === "National General" &&
        //     updateProducerCodeData.PrincetonAgentCode) ||
        //   carrier.label !== "National General")
        // ) {
        if (!updateProducerCodeData.isMA) {
          setSaveModal(true);
        } else if (
          updateProducerCodeData.isMA &&
          !updateProducerCodeData.MAProducerCodes
        ) {
          toast.fire(
            "Saving Failed",
            "M&A Producer Code is required if M&A is checked",
            "error"
          );
        } else if (
          updateProducerCodeData.isMA &&
          updateProducerCodeData.MAProducerCodes
        ) {
          setSaveModal(true);
        }
        // }
      } else {
        toast.fire(
          "Saving Failed",
          "All required fields must be filled!",
          "error"
        );
      }
    } else {
      toast.fire("Warning", "No changes has been made!", "warning");
    }
  };
  const Update = () => {
    setSaveButtonText("Saving...");
    setSaveModal(false);
    updatingProducerCode(updateProducerCodeData);
  };
  const handleMultiIssuedToSelect = (checkedEmp) => {
    var empList = [];
    checkedEmp.map((x) => {
      empList.push(x.value);
    });
    handleEditProducerModalInputs("EditProducerCode", "IssuedTo", empList);
    setSelectedIssuedTo(checkedEmp);
  };
  const handleMultiCrossSaleSelect = (checkedEmp) => {
    var empList = [];
    checkedEmp.map((x) => {
      empList.push(x.value);
    });
    handleEditProducerModalInputs("EditProducerCode", "CrossSale", empList);
    setSelectedCrossSale(checkedEmp);
  };

  return (
    <>
      <div className=" w-full ">
        <div className="animate-fade-in-down1 py-2 box-shadow border-primary border-l-2">
          <ConfirmBoxModal
            ModalTitle="Update Producer Code"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={saveModal}
            onClose={() => setSaveModal(false)}
            onClickFunction={() => {
              Update();
            }}
          />
          <div className="space-y-2 ">
            <div className="flex items-center gap-x-2 mr-2">
              <div className="ml-2 font-bold text-primary text-md">
                Edit:{" "}
                <p className="inline italic font-medium">
                  {" "}
                  Producer {data.carrierProducerCodeId}{" "}
                </p>
              </div>
              <button
                className={`flex items-center text-xs font-semibold justify-center gap-x-1 rounded-full ml-auto px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70 ${
                  saveButtonText === "Saving..." || isLoading || isRun === true
                    ? "text-gray-500 bg-gray-300"
                    : "text-white bg-senary "
                }`}
                disabled={
                  saveButtonText === "Saving..." || isLoading || isRun === true
                }
                onClick={() => {
                  ValidateRequiredFields();
                }}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div>{saveButtonText}</div>
              </button>
              <button
                className="flex items-center text-xs font-semibold text-white justify-center gap-x-1 rounded-full bg-red-500 px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
                onClick={() => {
                  Cancel();
                }}
              >
                <XCircleIcon className="h-4 w-4" />
                <div>Cancel</div>
              </button>
            </div>

            {!isLoading &&
            prodTypesOptions &&
            codeLevelOptions &&
            carrierOptions &&
            distChannelOpts &&
            lobTypes &&
            agenciesOptions ? (
              <>
                <div className="w-full border-b-2 border-secondary"></div>
                <div className="flex justify-between gap-x-2">
                  <div className="text-xs text-secondary italic font-normal ml-2">
                    <b> Note:</b> All fields with * are required to fill.
                  </div>{" "}
                  {/* <ReactTooltip
                    id="IsFranchise"
                    place="left"
                    effect="solid"
                    type="info"
                    className="font-normal"
                  />
                  <div></div>
                  {!user.isFranchise || !user.isNonFranchise ? (
                    <div></div>
                  ) : (
                    <div className="flex place-items-center gap-2 text-xs">
                      <label className="">Franchise:</label>

                      <input
                        data-tip={
                          "Note: Changing data category will reset selected value of Office or Producer, Issued To, Master Code and Roll Up Code."
                        }
                        data-for="IsFranchise"
                        type="checkbox"
                        className="w-5 h-5 bg-white shadow cursor-pointer"
                        defaultChecked={data.isFranchise}
                        onClick={(e) => {
                          setIsFranchiseChecked(e.target.checked);
                          handleFranchiseDistribution(e);
                        }}
                      />
                    </div>
                  )} */}
                </div>
                {/* 1st Row */}
                <div className="m-2 bg-white box-shadow rounded-lg h-full">
                  <div className="space-y-2 p-2 mb-3">
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Carrier:{" "}
                          </label>
                          <SelectInput
                            options={carrierOptions}
                            value={carrier}
                            onChange={(selectedOptions) => {
                              setDefaultProg(null);
                              setDefaultMasterCode(null);
                              setDefaultRollUp(0);
                              setCarrier(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "CarrierId",
                                selectedOptions ? selectedOptions : 0
                              );
                              setSelectedCarrierName(selectedOptions.label);
                            }}
                          />
                        </div>
                      </div>
                      {carrier?.label === "National General" && (
                        <div className="space-y-1 w-full text-xs">
                          <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                            <label className="flex text-left expandedLabel fontExpand">
                              <span className="text-red-500 ml-1">*</span>
                              Princeton Agent Code:{" "}
                            </label>
                            <TextInput
                              defaultValue={data.princetonAgentCode}
                              onChange={(e) =>
                                handleEditProducerModalInputs(
                                  "EditProducerCode",
                                  "PrincetonAgentCode",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {carrier?.label === "National General" && (
                        <div className="space-y-1 w-full text-xs">
                          <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                            <label className="fflex text-left expandedLabel fontExpand">
                              Master Agent Princeton ID:{" "}
                            </label>
                            <TextInput
                              value={masterAgentPrincetonId}
                              onChange={(e) =>
                                handleEditProducerModalInputs(
                                  "EditProducerCode",
                                  "masterAgentPrincetonId",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                if (!/^[0-9]*$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={15}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="border-b border-gray-200"></div>
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Distribution Channel:{" "}
                          </label>
                          <SelectInput
                            options={distChannelOpts}
                            value={distributionChannel}
                            onChange={(selectedOptions) => {
                              selectedOptions?.value === 6
                                ? setIsChannelFranchise(true)
                                : setIsChannelFranchise(false);
                              setDistributionChannel(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "DistributionChannelId",
                                selectedOptions
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Associated To:{" "}
                          </label>
                          <SelectInput
                            options={associations}
                            value={associatedTo}
                            onChange={(selectedOptions) => {
                              setAssociatedTo(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "AssociatedTo",
                                selectedOptions ? selectedOptions.value : 0
                              );
                            }}
                          />
                        </div>
                      </div>
                      {associatedTo?.value === "Office" ? (
                        <div className="space-y-1 w-full text-xs">
                          {deletedOffice ? (
                            <span className="text-red-500 text-xs3 float-right">
                              <b>Note: </b> Assigned office was deleted!
                            </span>
                          ) : (
                            ""
                          )}
                          <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                            <label className="fflex text-left expandedLabel fontExpand">
                              <span className="text-red-500 ml-1">*</span>
                              Office:{" "}
                            </label>
                            <SelectInput
                              options={agenciesOptions?.filter((x) =>
                                // x.officeType ===
                                // (distributionChannel?.label === "Franchise"
                                //   ? true
                                //   : false)
                                isFranchise
                                  ? x.officeType === "Franchise" &&
                                    distributionChannel?.label === "Franchise"
                                  : x.officeType !== "Franchise" &&
                                    distributionChannel?.label !== "Franchise"
                              )}
                              value={agency}
                              onChange={(e) => {
                                setAgency(e);
                                handleEditProducerModalInputs(
                                  "EditProducerCode",
                                  "OfficeCodeStoreNumber",
                                  e != null ? e.value : null,
                                  null,
                                  e?.officeCode,
                                  e?.storeNumber
                                );
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-1 w-full text-xs">
                          <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                            <label className="fflex text-left expandedLabel fontExpand">
                              <span className="text-red-500 ml-1">*</span>
                              Producer:{" "}
                            </label>
                            <SelectInput
                              options={
                                isFranchise
                                  ? employeeList
                                      ?.filter(
                                        (x) =>
                                          x.employeenumber !== null &&
                                          x.employeenumber !== "" &&
                                          x.employeeTypeName === "Franchise"
                                      )
                                      .map((x) => {
                                        return {
                                          label:
                                            (x.fullname ? x.fullname : "") +
                                            (x.employeenumber && x.fullname
                                              ? " - "
                                              : "") +
                                            (x.employeenumber
                                              ? x.employeenumber
                                              : ""),
                                          value: x.employeeId,
                                        };
                                      })
                                  : employeeList
                                      ?.filter(
                                        (x) =>
                                          x.employeenumber !== null &&
                                          x.employeenumber !== "" &&
                                          x.employeeTypeName !== "Franchise"
                                      )
                                      .map((x) => {
                                        return {
                                          label:
                                            (x.fullname ? x.fullname : "") +
                                            (x.employeenumber && x.fullname
                                              ? " - "
                                              : "") +
                                            (x.employeenumber
                                              ? x.employeenumber
                                              : ""),
                                          value: x.employeeId,
                                        };
                                      })
                              }
                              value={selectedEmployee}
                              onChange={(selectedOptions) => {
                                setSelectedEmployee(selectedOptions);
                                selectedOptions != null
                                  ? handleEditProducerModalInputs(
                                      "EditProducerCode",
                                      "Producer",
                                      selectedOptions != null
                                        ? selectedOptions.value
                                        : null
                                    )
                                  : setSelectedEmployee([]);
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Producer Code:{" "}
                          </label>
                          <TextInput
                            defaultValue={data.producerCodes}
                            onChange={(e) =>
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "ProducerCode",
                                e.target.value
                              )
                            }
                            onKeyPress={(event) => {
                              if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>{" "}
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Code Level:{" "}
                          </label>
                          <SelectInput
                            options={codeLevelOptions}
                            value={selectedCodeLevel}
                            onChange={(selectedOptions) => {
                              setSelectedCodeLevel(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "CodeLevel",
                                selectedOptions?.label
                              );
                            }}
                          />
                        </div>
                      </div>{" "}
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Sub Code:
                          </label>
                          <TextInput
                            defaultValue={data.producerSubCodes}
                            onChange={(e) =>
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "ProducerSubCode",
                                e.target.value
                              )
                            }
                            onKeyPress={(event) => {
                              if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* 2nd Row */}
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Line of Business:{" "}
                          </label>
                          <SelectInput
                            options={loboptions}
                            value={lob}
                            onChange={(selectedOptions) => {
                              setLob(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "LobId",
                                selectedOptions?.value
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            <span className="text-red-500 ml-1">*</span>
                            Producer Code Type:{" "}
                          </label>
                          <SelectInput
                            options={prodTypesOptions}
                            value={prodType}
                            onChange={(selectedOptions) => {
                              setprodType(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "ProducerCodeTypeId",
                                selectedOptions?.value
                                  ? selectedOptions.value
                                  : 0
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            {selectedisMA ? (
                              <span className="text-red-500 ml-1">*</span>
                            ) : (
                              ""
                            )}
                            M&A:{" "}
                          </label>
                          <div className="flex flex-row  gap-2">
                            <ReactTooltip
                              id="M&A"
                              place="top"
                              effect="solid"
                              type="info"
                            />
                            <input
                              data-tip={
                                selectedisMA
                                  ? "Uncheck if not M&A!"
                                  : "Check if M&A!"
                              }
                              data-for="M&A"
                              type="checkbox"
                              className="w-5 h-5 bg-white shadow cursor-pointer mt-1"
                              defaultChecked={data.isMA}
                              onClick={(e) => {
                                setselectedisMA(e.target.checked);
                                handleMACheckBox(e);
                              }}
                            />
                            {selectedisMA && (
                              <TextInput
                                className="ml-1 text-xs3 text-black"
                                placeholder="Producer Codes"
                                defaultValue={data.mAproducerCodes}
                                onChange={(e) =>
                                  handleEditProducerModalInputs(
                                    "EditProducerCode",
                                    "MAProducerCodes",
                                    e.target.value
                                  )
                                }
                                onKeyPress={(event) => {
                                  if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* 3rd Row */}
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="flex text-left expandedLabel fontExpand">
                            Issued To:
                          </label>
                          {isChannelFranchise ? (
                            <>
                              <MultiSelectInput
                                options={employeeList
                                  ?.filter(
                                    (x) =>
                                      x.status !== "Terminated" &&
                                      x.employeeTypeName === "Franchise" &&
                                      x.employeenumber !== null
                                  )
                                  .map((x) => {
                                    return {
                                      label:
                                        x.fullname + " - " + x.employeenumber,
                                      value: x.employeeId,
                                    };
                                  })}
                                isMulti
                                defaultValue={data.issuedToList}
                                value={selectedIssuedTo}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                handleMultiSelect={handleMultiIssuedToSelect}
                              />
                            </>
                          ) : (
                            <>
                              <MultiSelectInput
                                options={employeeList
                                  ?.filter(
                                    (x) =>
                                      x.status !== "Terminated" &&
                                      x.employeeTypeName !== "Franchise" &&
                                      x.employeenumber !== null
                                  )
                                  .map((x) => {
                                    return {
                                      label:
                                        x.fullname + " - " + x.employeenumber,
                                      value: x.employeeId,
                                    };
                                  })}
                                isMulti
                                defaultValue={data.issuedToList}
                                value={selectedIssuedTo}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                handleMultiSelect={handleMultiIssuedToSelect}
                              />
                            </>
                          )}
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="flex text-left expandedLabel fontExpand">
                            MGA:
                          </label>
                          <SelectInput
                            options={
                              mgaOpt &&
                              mgaOpt?.map((x) => {
                                return { value: x.id, label: x.mga1 };
                              })
                            }
                            defaultValue={
                              mgaOpt &&
                              mgaOpt
                                ?.map((x) => {
                                  return { value: x.id, label: x.mga1 };
                                })
                                .filter((l) => l.label === data.mga)[0]
                            }
                            onChange={(selectedOptions) => {
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "MGA",
                                selectedOptions?.value
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="flex text-left expandedLabel fontExpand">
                            Carrier Program Name:
                          </label>
                          <SelectInput
                            options={
                              carrier &&
                              cProgramOpt.data &&
                              cProgramOpt.data
                                .filter((x) => x.carrierId === carrier.value)
                                .map((x) => {
                                  return { value: x.id, label: x.programName };
                                })
                            }
                            isDisabled={!carrier}
                            value={defaultProg}
                            onChange={(selectedOptions) => {
                              setDefaultProg(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "Program",
                                selectedOptions ? selectedOptions.value : 0
                              );
                            }}
                          />
                        </div>
                      </div>{" "}
                    </div>{" "}
                    {/* 4th Row */}
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-x-5 gap-y-2">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Can Sell:
                          </label>
                          <MultiSelectInput
                            options={allStatesOpt}
                            isMulti
                            defaultValue={data.CrossSale}
                            value={selectedCrossSale}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            handleMultiSelect={handleMultiCrossSaleSelect}
                          />
                        </div>
                      </div>{" "}
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Status:
                          </label>
                          <ReactTooltip
                            place="top"
                            id="status"
                            effect="solid"
                            type="info"
                            getContent={[
                              () => {
                                return isChecked
                                  ? "Uncheck if Inactive!"
                                  : updateProducerCodeData.isActive
                                  ? "Uncheck if Inactive!"
                                  : "Check if Active!";
                              },
                            ]}
                          />
                          <div className="flex flex-row gap-2">
                            <input
                              data-tip={""}
                              data-for={"status"}
                              type="checkbox"
                              className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                              defaultChecked={data.isActive}
                              onClick={(e) => {
                                setIsChecked(e.target.checked);
                                handleCheckBox(e);
                              }}
                            />
                            <label className="self-center">
                              {isChecked ? "Active" : "Inactive"}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 5th status */}
                    <div className="w-full "></div>
                    <div className="space-y-4  border-t  grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2 mt-4">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Master Code Status:
                          </label>
                          <SelectInput
                            options={codeStatus}
                            isClearable={false}
                            // isDisabled={!carrier}
                            value={defaultMasterCodeStatus}
                            onChange={(selectedOptions) => {
                              setDefaultMasterCodeStatus(selectedOptions);
                              selectedOptions != null
                                ? handleEditProducerModalInputs(
                                    "EditProducerCode",
                                    "MasterCodeStatus",
                                    selectedOptions.value
                                  )
                                : setDefaultMasterCode(false);
                            }}
                          />
                        </div>
                      </div>
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Roll Up Code Status:
                          </label>
                          <SelectInput
                            options={codeStatus}
                            isClearable={false}
                            // isDisabled={!carrier}
                            value={defaultRollUpCodeStatus}
                            onChange={(selectedOptions) => {
                              setDefaultRollUpCodeStatus(selectedOptions);
                              selectedOptions != null
                                ? handleEditProducerModalInputs(
                                    "EditProducerCode",
                                    "RollUpCodeStatus",
                                    selectedOptions.value
                                  )
                                : setDefaultMasterCode(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>{" "}
                    {/* 5th Row */}
                    <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Master Code:
                          </label>
                          <SelectInput
                            options={masterCodeOptions?.filter(
                              (x) =>
                                x.isFranchise ===
                                updateProducerCodeData.isFranchise
                            )}
                            // isDisabled={!carrier}
                            value={defaultMasterCode}
                            onChange={(selectedOptions) => {
                              setDefaultMasterCode(selectedOptions);
                              handleEditProducerModalInputs(
                                "EditProducerCode",
                                "MasterCode",
                                selectedOptions ? selectedOptions.label : "",
                                selectedOptions
                                  ? selectedOptions.isActive
                                  : true
                              );
                            }}
                            isDisabled={
                              !updateProducerCodeData.CarrierId ? true : false
                            }
                          />
                        </div>
                      </div>{" "}
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
                          <label className="fflex text-left expandedLabel fontExpand">
                            Roll Up Code:
                          </label>
                          <SelectInput
                            options={rollUpCodeOptions?.filter(
                              (x) =>
                                x.isFranchise ===
                                updateProducerCodeData.isFranchise
                            )}
                            value={defaultRollUp}
                            onChange={(selectedOptions) => {
                              setDefaultRollUp(selectedOptions);
                              selectedOptions?.value != 0
                                ? handleEditProducerModalInputs(
                                    "EditProducerCode",
                                    "RollUpId",
                                    selectedOptions ? selectedOptions.value : 0,
                                    selectedOptions
                                      ? selectedOptions.isActive
                                      : true
                                  )
                                : setDefaultRollUp(0);
                            }}
                            isDisabled={
                              !updateProducerCodeData.CarrierId ? true : false
                            }
                          />
                        </div>
                      </div>{" "}
                    </div>{" "}
                  </div>
                </div>
              </>
            ) : (
              <CustomLoaderForm />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProducerCodeModal;
